import { useDispatch, useSelector } from 'react-redux';
import { deauthenticate } from 'store/auth';
import { common } from 'lang/en.json';
import styles from 'styles/modules/Nav.module.scss';
import Link from 'next/link';
import Avatar from 'components/Avatar';
import { useRef, useState, useEffect } from 'react';
import useOutsideClick from 'hooks/useOutsideClick';
import { fetchCurrentUserProfile } from 'store/currentUser';

const NavDropdown = () => {
    const auth = useSelector(({ auth }) => auth);
    const currentUserProfile = useSelector(
        ({ currentUser }) => currentUser.profile
    );

    const { name, logo, slug, plan } = currentUserProfile || {};
    const { isFTEditor, isAdmin, isJournalist } = auth;

    const [expanded, setExpanded] = useState();
    const dispatch = useDispatch();
    const profileRef = useRef(null);

    useEffect(() => {
        if (auth.isAuthenticated && auth.company && slug !== auth.company) {
            dispatch(fetchCurrentUserProfile(auth.company));
        }
    }, [auth.isAuthenticated, auth.company, slug, dispatch]);

    useOutsideClick(profileRef, () => {
        if (expanded) {
            setExpanded(false);
        }
    });

    return (
        <div
            className={styles.profile}
            onClick={() => setExpanded(!expanded)}
            ref={profileRef}
        >
            <Link href={`/${slug}`}>
                <Avatar
                    isLegend={plan?.type === 'legend'}
                    isFTEditor={isFTEditor}
                    isAdmin={isAdmin}
                    isJournalist={isJournalist}
                    logo={logo}
                    name={name}
                    plan={plan}
                />
            </Link>
            <ul
                className={[
                    'border-gray',
                    styles.dropdown,
                    styles[plan?.type],
                    expanded ? styles.active : '',
                ].join(' ')}
            >
                <li onClick={() => dispatch(deauthenticate())}>
                    {common.logout}
                </li>
            </ul>
        </div>
    );
};

export default NavDropdown;
